export default "__VITE_ASSET__3nJX_NIe__"